
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LensDownstreamMetricsQuery, LensDownstreamMetricsQueryVariables, MetricsDisplayGridRowDataFragment, MetricSortOrder , LensDownstreamMetricsDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataForMetric, MetricsDisplayGrid, MetricsDisplayGridRowData } from '../sharedDisplayGrid/MetricsDisplayGrid';
import { MetricsValidSortFields } from '../sorting/sortProviders/MetricsGridSortProvider';

type QueryVariables = LensDownstreamMetricsQueryVariables;
type QueryResults = LensDownstreamMetricsQuery;
type QueryResultListNode = MetricsDisplayGridRowDataFragment;
type GridRowData = MetricsDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses && resultData.lenses[0]?.downstreamMetricsConnection;
}

export type LensDownstreamMetricsQueryGridProps =
  GridSortProps<MetricsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export function LensDownstreamMetricsQueryGrid(props: LensDownstreamMetricsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamMetricsLineageGridMessage();

  return <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
    queryGql={LensDownstreamMetricsDocument}
    partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as MetricSortOrder }}
    selectConnectionListResult={selectConnectionListResult}
    mapResultNode={getRowDataForMetric}
  >
    {({ rowStore }) => <MetricsDisplayGrid
      rowStore={rowStore}
      emptyGridMessage={emptyGridMessage}
      rowCount={props.rowCount}
      orderBy={props.orderBy}
      updateSortOrder={props.updateSortOrder}
    />}
  </PaginatedQueryWrapper>;
}
